export interface IPeriodicWaveConstraints {
    disableNormalization: boolean;
}
